/**
 * @Description Container for Fasat Tab
 * @FileName fasatTab.js
 * @Author SAMAPTI TALUKDAR-talusam
 * @CreatedOn 04 March, 2021 05:38:22
 * @IssueID 623
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Tabs } from '@manulife/mux';
import './fasatTab.scss';
import './fasatTabs.scss';
import './fasatTabStyle.scss';

function FasatTab(props) {
  const {
    tabContent,
    tabItems,
    variant,
    selectedTab,
    controlledSelectedTab,
    onChange,
  } = props;

  // Support both selectedTab (standard) and controlledSelectedTab (legacy prop name)
  const activeTabValue = selectedTab ?? controlledSelectedTab;

  // MUX Tabs expects ID, but legacy code uses value
  // Convert value to ID for MUX selectedTab prop
  const activeTabItem = tabItems.find((item) => item.value === activeTabValue);
  const activeTabId = activeTabItem?.id || activeTabValue;

  // MUX Tabs onChange passes the tab ID, but legacy code expects tab value
  // Convert ID to value before calling onChange
  const handleTabChange = (tabId) => {
    if (onChange) {
      const selectedTabItem = tabItems.find((item) => item.id === tabId);
      const tabValue = selectedTabItem?.value || tabId;
      onChange(tabValue);
    }
  };

  return (
    <div className="fasatTab">
      <Tabs
        tabItems={tabItems}
        variant={variant}
        selectedTab={activeTabId}
        onChange={handleTabChange}
      >
        {tabContent && tabContent.map((item, index) => {
          const panelId = tabItems?.[index]?.id;
          // Only render active tab content to prevent unnecessary component mounting
          // This improves performance and prevents errors in inactive tabs that may be waiting for data
          const isActiveTab = panelId === activeTabId || (tabItems?.[index]?.value === activeTabValue);
          return (
            <Tabs.Panel
              key={panelId || `tab-panel-${index}`}
              id={panelId}
            >
              {isActiveTab ? item.content : null}
            </Tabs.Panel>
          );
        })}
      </Tabs>
    </div>
  );
}

FasatTab.propTypes = {
  tabContent: PropTypes.arrayOf(PropTypes.shape()),
  tabItems: PropTypes.arrayOf(PropTypes.shape()),
  variant: PropTypes.string,
  selectedTab: PropTypes.string,
  controlledSelectedTab: PropTypes.string,
  onChange: PropTypes.func,
};

FasatTab.defaultProps = {
  tabContent: [],
  tabItems: [],
  variant: Tabs.VARIANT.GREY,
  selectedTab: undefined,
  controlledSelectedTab: undefined,
  onChange: undefined,
};

export default FasatTab;
